import { render, staticRenderFns } from "./BuyerCallLogs.vue?vue&type=template&id=0480d4a8&scoped=true"
import script from "./BuyerCallLogs.vue?vue&type=script&lang=js"
export * from "./BuyerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480d4a8",
  null
  
)

export default component.exports